<template>
  <!-- 底部 -->
  <div class="case">
    <div>
      <div class="title">{{title}}</div>
      <div class="content">
        <div class="hasImg" v-for='item of list' :key='item.title'>
          <img :src="item.img" alt="" />
          <span class="headline">{{ item.title }}</span>
          <span class="desc"
            >{{ item.desc }}</span
          >
        </div>
      </div>
      <div class="more" id="isPCF" @click="go">
        <span>查看更多案例</span>
        <img src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/common/right.png" alt="" />
      </div>
    </div>
  </div>
</template>
<script>

export default {
  props: {
    title: {
      type: String,
      default: '客户案例'
    },
    list: {
      type: Array,
      default: ()=>{
        return []
      }
    }
  },
  data: function() {
    return {
      data: {
        menu_list: []
      }
    };
  },
  created() {

  },
  methods: {
    go(){
      this.$router.push({
        name: 'eg'
      })
    }
  }
};
</script>
<style lang="less" scoped>
.case {
  width: 100%;
  background: #fff;
  > div {
    width: 1200px;
    height: 691px;
    margin: 0 auto;
    padding-top: 1px;
    .title {
      font-size: 42px;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.6);
      line-height: 1;
      text-align: center;
      margin-top: 48px;
    }
    .content {
      width: 100%;
      display: flex;
      height: 391px;
      margin-top: 49px;
      .hasImg {
        width: 33.3%;
        height: 100%;
        box-sizing: border-box;
        border-right: 1px solid #dadada;
        padding: 0 30px;
        &:nth-child(3) {
          border: none;
        }
        img {
          width: 100%;
          height: 200px;
        }
        .headline {
          margin-top: 40px;
          line-height: 1;
          font-size: 28px;
          font-weight: bold;
          color: #9fa1b4;
          display: block;
          &:nth-of-type(2) {
            margin-top: 10px;
          }
        }
        .desc {
          display: block;
          font-size: 18px;
          font-weight: 400;
          color: #9fa1b4;
          line-height: 24px;
          margin-top: 20px;
          word-break: break-all;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      .noImg {
        width: 33.3%;
        height: 100%;
        > div {
          width: 100%;
          padding: 15px;
          box-sizing: border-box;
          &:last-child {
            border-top: 1px solid #dadada;
          }
          .headline {
            font-size: 28px;
            font-weight: bold;
            color: #9fa1b4;
            line-height: 40px;
            min-height: 92px;
          }
          .desc {
            font-size: 18px;
            font-weight: 400;
            color: #9fa1b4;
            line-height: 24px;
            margin-top: 20px;
          }
        }
      }
    }
    .more {
      margin-top: 64px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      span {
        font-size: 24px;
        color: #9fa1b4;
        line-height: 1;
      }
      img{
        width: 22px;
        height: 18px;
        margin-left: 6px;
        margin-top: -4px;
      }
    }
  }
}
@media (max-width: 1000px) {
  div.case{
    width: 100%;
    height: auto;
    > div{
      width: 100%;
      height: auto;
      .title{
        font-size: 44px;
        margin-top: 80px;
      }
      .content{
        display: block;
        height: auto;
        padding-bottom: 90px;
        .hasImg, .noImg{
          width: 100%;
          height: auto;
          padding: 0 48px;
          margin-top: 80px;
          img{
            width: 100%;
            height: 386px;
          }
          .headline{
            font-size: 36px;
            margin-top: 28px;
            color: #8D8E9D;
          }
          .desc{
            font-size: 28px;
            margin-top: 12px;
            line-height: 1.3;
            color: #8D8E9D;
          }
        }
      }
    }
  }
}
</style>
